import React from 'react';
import type { Project } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useBoard } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/board/index.tsx';
import ProjectKeyboardShortcuts from '@atlassian/jira-software-keyboard-shortcuts/src/ui/project-shortcuts/index.tsx';

const ProjectShortcuts = ({ project }: { project: Project }) => {
	const { data: board, loading, error } = useBoard();

	if (!board || loading || error) {
		return null;
	}

	return <ProjectKeyboardShortcuts isCMPBoard projectKey={project.key} boardId={board.id} />;
};

export default ProjectShortcuts;
